import { CSpinner } from "@coreui/react";

export default function Loading({ color = "secondary", size = "md" }) {
  return (
    <div className="d-flex w-100 justify-content-center p-2">
      <CSpinner color={color} size={size} />
    </div>
  );
}
